import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 13H2v8h19v-8zm0-10H2v8h19V3z"
}), 'ViewAgendaSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewAgendaSharp.js
// module id = 7068
// module chunks = 2